// Portfolio Configuration
export const portfolioConfig = {
  name: "OMAR KHLIFI",
  title: "Creative Developer",
  tagline: "Crafting immersive 3D experiences, building scalable web applications, and leveraging AI to create innovative solutions.",
  profilePicture: "/profile-placeholder.svg",
  
  skills: [
    "3D Game Dev",
    "Full Stack",
    "AI Expert"
  ],
  
  about: {
    whoIAm: "I'm a passionate developer who brings ideas to life through code and creativity. With expertise spanning 3D game development, full-stack web applications, and cutting-edge AI solutions, I create experiences that push boundaries.",
    journey: "My journey combines technical excellence with artistic vision, resulting in projects that are not only functional but also visually stunning and user-friendly."
  },
  
  contact: {
    email: "omar.khlifi@example.com",
    github: "https://github.com/omarkhlifi",
    linkedin: "https://linkedin.com/in/omarkhlifi",
    twitter: "https://twitter.com/omarkhlifi"
  }
};

// Detailed Projects Data
export const projectsData = [
  {
    "id": "elemental-runes-3d",
    "title": "Elemental Runes 3D",
    "category": "Game Development",
    "shortDescription": "A physics-driven 3D card battle game built in Unity featuring dynamic hand fanning, automated turn state management, and custom meld evaluation.",
    "tech": ["Unity 6", "C#", "TextMeshPro", "3D Physics"],
    "github": "https://github.com/omarkhlifi/elemental-runes-3d",
    "image": "/projects/elemental-runes-3d.jpg",
    "color": "mystic-purple",
    "year": "2026",
    "duration": "3 days (in progress)"
  },
  {
    "id": "3d-portfolio",
    "title": "3D Developer Portfolio",
    "category": "Personal Portfolio",
    "shortDescription": "A visually stunning 3D portfolio showcasing my skills and projects, built with React and Three.js.",
    "tech": ["React", "Three.js", "React Three Fiber", "Framer Motion"],
    "github": "https://github.com/omarkhlifi/omarkhlifi.github.io",
    "image": "/projects/3d-portfolio.jpg",
    "color": "cyber-cyan",
    "year": "2026",
    "duration": "2 weeks"
  },
  {
    "id": "vrmania-custom-pos",
    "title": "VR Mania Custom POS",
    "category": "Enterprise Business System",
    "shortDescription": "Custom multi-branch POS and business management platform for VR Mania Kuwait.",
    "tech": ["React", "TypeScript", "Supabase"],
    "github": "https://github.com/omarkhlifi/vrmania-custom-pos-showcase",
    "image": "/projects/vrmania-custom-pos.jpg",
    "color": "cyber-red",
    "year": "2026",
    "duration": "3 months"
  },
  {
    "id": "vrmaniaq8-website",
    "title": "VR Mania Q8 Website",
    "category": "Frontend Web Development",
    "shortDescription": "Modern, responsive company website built for VR Mania Q8.",
    "tech": ["React", "TypeScript", "Tailwind CSS"],
    "github": "https://github.com/omarkhlifi/vrmaniaq8-website-showcase",
    "image": "/projects/vrmaniaq8-website.jpg",
    "color": "cyber-cyan",
    "year": "2026",
    "duration": "2 weeks"
  },
  {
    "id": "vrtechq8-website",
    "title": "VR Tech Q8 Website",
    "category": "Frontend Web Development",
    "shortDescription": "Enterprise website showcasing VR products and business solutions.",
    "tech": ["React", "TypeScript", "Tailwind CSS"],
    "github": "https://github.com/omarkhlifi/vrtechq8-website-showcase",
    "image": "/projects/vrtechq8-website.jpg",
    "color": "cyber-green",
    "year": "2026",
    "duration": "3 weeks"
  },
  {
    "id": "g-cafe-pos",
    "title": "G Cafe POS System",
    "category": "Point of Sale System",
    "shortDescription": "Modern POS system for order processing, payments, and business operations.",
    "tech": ["React", "TypeScript", "Supabase"],
    "github": "https://github.com/omarkhlifi/g-cafe-pos-showcase",
    "image": "/projects/g-cafe-pos.jpg",
    "color": "cyber-purple",
    "year": "2026",
    "duration": "1 month"
  },
  {
    "id": "g-cafe-menu",
    "title": "G Cafe Digital Menu",
    "category": "Web Application",
    "shortDescription": "Responsive digital menu with Firebase-powered product management.",
    "tech": ["HTML", "CSS", "JavaScript", "Firebase"],
    "github": "https://github.com/omarkhlifi/g-cafe-menu-showcase",
    "image": "/projects/g-cafe-menu.jpg",
    "color": "cyber-orange",
    "year": "2025",
    "duration": "1 week"
  }
];